import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { debounce } from 'lodash'

class InfiniteScroll extends Component {
  state = {
    error: false,
    isLoading: false,
  }

  loadMore = () => {
    const { error, isLoading } = this.state
    const { inverse, reference } = this.props

    if (error || isLoading) return

    const element = document.getElementById('infinite-scroll')
    if (!element) return

    if (inverse) {
      // NOTE: Negate `scrollTop`, due to `flex-direction: column-reverse` reverses `scrollTop` value
      const currentScroll = -element.scrollTop
      const maxScrollValue = reference.current.scrollHeight - reference.current.clientHeight
      if (currentScroll > maxScrollValue - 200) {
        this.loadData()
      }
    } else if (element.offsetHeight + Math.ceil(element.scrollTop) === element.scrollHeight) {
      this.loadData()
    }
  }

  loadData = () => {
    const { onEndReached } = this.props

    if (!onEndReached) {
      return new Error('OnEndReached not specified!')
    }

    this.setState({ isLoading: true }, async () => {
      try {
        await onEndReached()
      } catch ({ message }) {
        this.setState({ error: message })
      } finally {
        this.setState({
          isLoading: false,
        })
      }
    })
  }

  render() {
    const { error, isLoading } = this.state
    const { renderItem, renderLastItem, data, className, style, isLoadedAll, reference, inverse } =
      this.props

    return (
      <div
        id="infinite-scroll"
        onScroll={isLoadedAll ? () => null : debounce(this.loadMore, 500)}
        style={{ overflowY: 'auto', width: '100%', ...style }}
        className={className}
        ref={reference}
      >
        {renderLastItem ? renderLastItem() : null}
        {inverse && !isLoadedAll && isLoading && data.length ? (
          <div
            style={{
              textAlign: 'center',
              zIndex: '2',
              width: '50%',
              fontSize: '18px',
              backgroundColor: '#f8f8f8',
              position: 'absolute',
              top: '0',
              left: '25%',
            }}
          >
            Loading...
          </div>
        ) : null}
        {data.map((item, i) => (
          <React.Fragment key={`${item.id}_${i}`}>{renderItem(item)}</React.Fragment>
        ))}
        {error && (
          <div style={{ color: '#900', textAlign: 'center', width: '100%', fontSize: '13px' }}>
            {error}
          </div>
        )}
        {!inverse && isLoading && (
          <div style={{ textAlign: 'center', width: '100%', fontSize: '13px' }}>Loading...</div>
        )}
      </div>
    )
  }
}

InfiniteScroll.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  renderItem: function (item) {
    if (!item) {
      return new Error('Item argument not specified!')
    }
  },
  renderLastItem: PropTypes.func,
  onEndReached: PropTypes.func,
  className: PropTypes.string,
  style: PropTypes.object,
  isLoadedAll: PropTypes.bool,
  inverse: PropTypes.bool,
  reference: PropTypes.object,
}

InfiniteScroll.defaultProps = {
  data: [],
  style: {},
}

export default InfiniteScroll
